export default function HydroelectricIcon() {
    return (
        <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 17.5899C14.0873 17.5899 17.4007 14.2724 17.4007 10.1799C17.4007 6.08748 14.0873 2.7699 10 2.7699C5.91272 2.7699 2.59932 6.08748 2.59932 10.1799C2.59932 14.2724 5.91272 17.5899 10 17.5899Z"
                fill="#003953"
            />
            <path
                d="M9.72865 10.1799C9.37271 11.1432 9.03792 12.0395 8.70665 12.9357C8.41767 13.7226 8.64322 14.5518 9.25994 15.007C9.80971 15.4128 10.6344 15.3704 11.2405 14.9117C11.9101 14.4036 12.1779 13.6203 11.8502 12.8722C11.4308 11.9195 10.8458 11.0691 10.0493 10.3846C9.94362 10.2928 9.81324 10.2328 9.72513 10.1799H9.72865Z"
                fill="white"
            />
            <path
                d="M7.73752 4.82706C7.56131 5.29989 7.39568 5.74096 7.2371 6.18203C7.09613 6.57018 7.20538 6.97596 7.50845 7.20179C7.77981 7.39939 8.18509 7.38175 8.48111 7.15592C8.80886 6.90539 8.94277 6.52078 8.78066 6.1538C8.57626 5.6845 8.28729 5.26813 7.89611 4.92939C7.84325 4.88351 7.77981 4.85529 7.73752 4.83059V4.82706Z"
                fill="white"
            />
            <path
                d="M12.7594 6.88776C12.4916 7.60759 12.2414 8.27802 11.9947 8.94845C11.7797 9.53772 11.9453 10.1588 12.407 10.4975C12.8193 10.801 13.436 10.7692 13.8907 10.4269C14.3911 10.0458 14.592 9.46009 14.3453 8.90258C14.0316 8.1898 13.5946 7.55466 12.999 7.03949C12.9215 6.97244 12.8193 6.92657 12.7559 6.88776H12.7594Z"
                fill="white"
            />
            <path
                d="M6.0565 9.58713C5.89792 10.0106 5.75342 10.4022 5.60893 10.7974C5.48206 11.1432 5.58074 11.5067 5.8521 11.7078C6.09526 11.8842 6.45472 11.8666 6.72256 11.6655C7.01506 11.4432 7.13488 11.0974 6.99039 10.7692C6.80714 10.3493 6.54988 9.97527 6.19746 9.67534C6.15165 9.63653 6.09174 9.6083 6.0565 9.58713Z"
                fill="white"
            />
        </svg>
    );
}
